import React from "react";
import { DropdownMenuItem } from "@radix-ui/react-dropdown-menu";

import { DropdownMenuContent } from "../ui";
import { ChartOptionsMenuItemProps } from "./types";
import { cn } from "@/lib/utils";

export const ChartOptionsMenuItem = ({
  menuOptions,
}: ChartOptionsMenuItemProps) => {
  return (
    <DropdownMenuContent align="end" className="p-2">
      {menuOptions?.map((option) => (
        <DropdownMenuItem
          key={option.label}
          onClick={option.onClick}
          disabled={option.disabled}
          className={cn(
            "font-xl flex items-center gap-2 rounded-sm border-0 px-2 py-1.5 outline-none select-none",
            "data-[highlighted]:bg-accent data-[highlighted]:text-accent-foreground",
            option.disabled
              ? "cursor-not-allowed opacity-50"
              : "cursor-pointer",
          )}
        >
          {option?.icon} {option.label}
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  );
};
